import { RealEstateFeatures } from '../../../../../@types/types'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'

export const tenantShortTermAccommodationRentEstateFeatures = [
  RealEstateFeatures.BALCONY_TERRACE,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.ELEVATOR,
  RealEstateFeatures.SHARED_GARDEN,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
]

export const tenantShortTermAccommodationRentBuildingTypeOptions = [
  BuildingTypeOption.FLAT,
  BuildingTypeOption.HOUSE,
  BuildingTypeOption.ROOM,
  BuildingTypeOption.APARTMENT,
]
